import React  from "react";
import { Col, Container, Row } from "react-bootstrap";
import carIocn from "../../assets/images/car.png";
import img1 from "../../assets/images/1.png";
import img2 from "../../assets/images/airport.png";
import img3 from "../../assets/images/guidepost.png";
import img4 from "../../assets/images/One-wayTaxi.png";
import img5 from "../../assets/images/rinse.png";
import img6 from "../../assets/images/Corporate.png";
import hotel from "../../assets/images/hotel.png";
import Corporate from "../../assets/images/Corporate.png";
import Fleet from "../../assets/images/fleet-management.png";
export default function OurServices() {
 
  return (
    <div className="ourServices">
      <Container>
         <div className="section-title mb-4">
          <img src={carIocn} alt="" />
          <h2>Our Services</h2>
          <span>Complete cab solutions for every journey across Varanasi. Book Your Ride Instantly With Taxi Service Varanasi. </span>
        </div>

        <Row> 
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={img1} className="white-icon" alt="" />
                <h4 className="mt-3">Local Taxi Service</h4>
                <div>Quick and convenient rides within Varanasi city limits for all your daily needs. Visit Temples & Ghats easily.</div>
              </div>
            </Col> 
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={img2} className="white-icon" alt="" />
                <h4 className="mt-3">Airport Taxi</h4>
                <div>Reliable transfers to/from Lal Bahadur Shastri International Airport with on-time guarantee.</div>
              </div>
            </Col> 
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={img3} className="white-icon" alt="" />
                <h4 className="mt-3">Outstation Trips</h4>
                <div>Comfortable long-distance travel to Prayagraj, Ayodhya, Bodhgaya and beyond. Experienced drivers.</div>
              </div>
            </Col> 

            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={img4} className="white-icon" alt="" />
                <h4 className="mt-3">One-way Taxi</h4>
                <div>Cost-effective one-way trips without paying for return journey charges. Best rates on all routes.</div>
              </div>
            </Col>
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={img5} className="white-icon" alt="" />
                <h4 className="mt-3">Round Trip</h4>
                <div>Complete round-trip packages for outstation journeys with flexible duration and value packages.</div>
              </div>
            </Col>
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={img6} className="white-icon" alt="" />
                <h4 className="mt-3">Corporate Cabs</h4>
                <div>Dedicated cab solutions for corporate employees and business events. Bulk bookings and priority service.</div>
              </div>
            </Col>
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={hotel} className="white-icon" alt="" />
                <h4 className="mt-3">Hotel Booking</h4>
                <div>Easy and reliable hotel booking with budget to luxury options. Best prices, prime locations, and comfortable stays.</div>
              </div>
            </Col>
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={Corporate} className="white-icon" alt="" />
                <h4 className="mt-3">Corporate Car Rental</h4>
                <div>Easy and reliable hotel booking with budget to luxury options. Best prices, prime locations, and comfortable stays.</div>
              </div>
            </Col>
             <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                <img src={Fleet} className="white-icon" alt="" />
                <h4 className="mt-3">Fleet Leasing</h4>
                <div>Easy and reliable hotel booking with budget to luxury options. Best prices, prime locations, and comfortable stays.</div>
              </div>
            </Col>
        </Row>
      </Container>
    </div>
  );
}
